import { BehaviorSubject, Observable } from 'rxjs';
import { CalibrationAudit, CalibrationAuditFilter } from './calibration';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { catchError, finalize } from 'rxjs/operators';

import { CalibrationService } from '../services/calibration.service';
import { of } from 'rxjs';
import { ParticleCalibrationAudit, ParticlesCalibrationAuditFilter } from './particleCalibration';
import { ParticleCalibrationService } from '../services/particleCalibration.service';

export class ParticlesAuditDataSource implements DataSource<ParticleCalibrationAudit> {

    private calibrationsSubject = new BehaviorSubject<ParticleCalibrationAudit[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);
    private totalSubject = new BehaviorSubject<number>(0);

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public loading$ = this.loadingSubject.asObservable();
    // eslint-disable-next-line @typescript-eslint/member-ordering
    public totalItems$ = this.totalSubject.asObservable();

    constructor(private service: ParticleCalibrationService) { }

    connect(_collectionViewer: CollectionViewer): Observable<ParticleCalibrationAudit[]> {
        return this.calibrationsSubject.asObservable();
    }

    disconnect(_collectionViewer: CollectionViewer): void {
        this.calibrationsSubject.complete();
        this.loadingSubject.complete();
        this.totalSubject.complete();
    }

    loadCalibrationAudit(id: number, filter = new ParticlesCalibrationAuditFilter()): void {

        this.loadingSubject.next(true);

        this.service.getAudit(id, filter).pipe(
            catchError(() => of([])),
            finalize(() => this.loadingSubject.next(false))
        ).subscribe(data => {
            if (data && data.content) {
                this.calibrationsSubject.next(data.content as ParticleCalibrationAudit[]);
                this.totalSubject.next(data.totalElements as number);
            } else if (data) {
                this.calibrationsSubject.next(data as ParticleCalibrationAudit[]);
                this.totalSubject.next(data.length as number);
            } else {
                this.calibrationsSubject.next([]);
                this.totalSubject.next(0);
            }
        });
    }
}
